import Icon from "../../icons/loading.gif";

const LoaderIcon = ({ ...rest }) => {
	return <img src={Icon} {...rest} />;
};

export default LoaderIcon;
